import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorDualAsset = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M14.939 5.915a.75.75 0 0 1 .83-.66 6.751 6.751 0 0 1 .111 13.4.75.75 0 1 1-.194-1.488A5.251 5.251 0 0 0 15.6 6.745a.75.75 0 0 1-.661-.83Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M10 4.75a7.25 7.25 0 1 0 0 14.5 7.25 7.25 0 0 0 0-14.5ZM1.25 12a8.75 8.75 0 1 1 17.5 0 8.75 8.75 0 0 1-17.5 0Z"
    />
    <path fill="#F7A600" d="M12 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" />
  </svg>
);
export default SvgTwoColorDualAsset;
